// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"3241":"7dadfe83073513f503aa","4281":"f442363f7a2bc87774d4"}[chunkId] + ".js";
};